import { computed } from 'vue';
import { IPresentableEntity } from '@/models/available-entities.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class EntitiesAndGeotargetingCode {
	public isLoading = computed((): boolean => {
		const loadingStatus =  store.getters.loadingStatusEntities();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public availableEntities = computed((): IPresentableEntity[] => {
		return store.getters.availableEntities();
	});

	public async mounted(): Promise<void> {
		await this.loadEssentialData();
		store.mutations.incrementLoadCount();
	}

	private async loadEssentialData(): Promise<void> {
		if (this.availableEntities.value.length) {
			return;
		}

		await campaignPresenter.retrieveCampaignListingEntities();
		campaignPresenter.updateOriginalCampaignData();
	}
}
